export function initNewsFilter() {
  const categorySelect = document.getElementById('news-category-filter');
  if (!categorySelect) {
    return;
  }

  categorySelect.addEventListener('change', (event) => {
    const targetUrl = event.target.value;
    if (targetUrl) {
      window.location.href = targetUrl;
    }
  });
}
